<template>
	<div class="w-full p-8 my-16 text-center">
		<LogoFullColor class="w-full my-2" />
		<h2 class="py-6 text-4xl">
			{{ thankYouText }}
		</h2>

		<span
			v-if="showInternetUnvailableCopy"
			class="text-dimmed"
		>
			{{ $t('get-fiber.complete-page.internet-unavailable-subtitle') }}
		</span>
		<div v-else-if="!hideSubtitle">
			<div class="text-dimmed max-w-lg text-pretty mx-auto">
				{{ $t('get-fiber.complete-page.subtitle') }}
			</div>

			<NuxtLink
				to="/login"
				class="block max-w-xs m-auto mt-8 font-bold leading-10 text-center text-inverted transition-all duration-200 ease-in-out border-2 rounded-lg opacity-100 hover:bg-primary-muted hover:border-primary-muted h-11 bg-primary focus:outline-none focus:ring focus:ring-offset-2 focus:ring-offset-current focus:ring-primary focus:ring-opacity-80 border-primary"
			>
				{{ $t('get-fiber.complete-page.login-cta') }}
			</NuxtLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useAddressLocalStorage } from '@/composables/useLocalStorage'
import { UNAVAILABLE } from '@/constants/signup-queries'

const props = defineProps({
	thankYouText: {
		type: String,
		default: 'Thank you'
	},
	hideSubtitle: {
		type: Boolean,
		default: false
	}
})
const { thankYouText } = toRefs(props)

const { cachedAddressResponse } = useAddressLocalStorage()

const status = computed(() => {
	return cachedAddressResponse?.value?.status
})

const showInternetUnvailableCopy = computed(() => {
	return status.value === UNAVAILABLE
})

onMounted(() => {
	window.scroll({
		top: 0,
		behavior: 'smooth'
	})
})
</script>
